import type React from "react";
import { memo } from "react";
import type { MainService } from "../../main-service";
import type { Session, SessionSummary } from "../../types/core";
import { HistoryModal } from "./modals/HistoryModal";
import { LegalModal, type LegalType } from "./modals/LegalModal";
import { PreferenceModal } from "./modals/PreferenceModal";
import { SummaryModal } from "./modals/SummaryModal";

interface AppModalsProps {
	isPrefsOpen: boolean;
	onPrefsClose: () => void;
	isHistoryOpen: boolean;
	onHistoryClose: () => void;
	isSummaryOpen: boolean;
	onSummaryClose: () => void;
	isLegalOpen: boolean;
	onLegalClose: () => void;
	legalType: LegalType;
	service: MainService | null;
	currentSessionId: string | null;
	summary: SessionSummary | null;
	lastSession: Session | null;
}

/**
 * Container for all application modals, memoized to prevent re-rendering
 * the entire modal tree during frequent transcription updates.
 */
export const AppModals: React.FC<AppModalsProps> = memo(
	({
		isPrefsOpen,
		onPrefsClose,
		isHistoryOpen,
		onHistoryClose,
		isSummaryOpen,
		onSummaryClose,
		isLegalOpen,
		onLegalClose,
		legalType,
		service,
		currentSessionId,
		summary,
		lastSession,
	}) => {
		return (
			<>
				<PreferenceModal
					isOpen={isPrefsOpen}
					onClose={onPrefsClose}
					service={service}
				/>

				<HistoryModal
					isOpen={isHistoryOpen}
					onClose={onHistoryClose}
					service={service}
					currentSessionId={currentSessionId}
				/>

				<SummaryModal
					isOpen={isSummaryOpen}
					onClose={onSummaryClose}
					summary={summary}
					session={lastSession}
				/>

				<LegalModal
					isOpen={isLegalOpen}
					onClose={onLegalClose}
					type={legalType}
				/>
			</>
		);
	},
);
